import fetch from "../axiosConfig";

export function getUserMenusPerms(data) {
  return fetch({
    url: "/user/getUserMenusPerms",
    method: "get",
  });
}
//获取当前登录用户的信息
export function usergetUserInfo(data) {
  return fetch({
    url: "/user/getUserInfo",
    method: "get",
  });
}
//登录日志-分页列表
export function loginLogpage(data) {
  return fetch({
    url: "/loginLog/page",
    method: "post",
  });
}




// WEBPACK FOOTER //
// ./src/api/system/user.js